<template>
  <div class="btnManage">
    <div class="table-info">
      <div class="breadcrumb">
        <span>位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>按钮管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <h3>按钮管理</h3>
    </div>
    <div class="table-content">
      <div class="tool-bar">
        <span>关键字：</span>
        <el-input size="small" placeholder="请输入" width="264" class="key-word" v-model="keyword"></el-input>
        <span>状态：</span>
        <el-select v-model="value" size="small" class="status">
          <el-option :key="1" label="启用" :value="1"></el-option>
          <el-option :key="2" label="禁用" :value="2"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="searchBtn(keyword,value)" v-if="isCompleted && isShowButton('查询')">查询</el-button>
        <el-button size="small" @click="reset" v-if="isCompleted && isShowButton('重置')">重置</el-button>
        <el-button size="small" type="primary" @click="handleAdd('新增')" v-if="isCompleted && isShowButton('新增按钮')">新增按钮</el-button>
      </div>
      <el-table
        :data="tableData"
        v-loading="loading"
        style="width: 100%">
        <el-table-column
          label="按钮名称"
          prop="name">
        </el-table-column>
        <el-table-column
          label="所属菜单"
          prop="menuName">
        </el-table-column>
        <el-table-column
          label="凭证"
          prop="voucher">
        </el-table-column>
        <el-table-column
          label="状态"
          prop="status">
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button class="marginRight10" type="text" @click="handleEdit(scope.row)">编辑</el-button>
            <el-popover
                placement="top"

                v-model="scope.row.isAbolish">
                <p><i class="el-icon-error" style="color:red;"></i>该操作不可逆,是否确认？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="scope.row.isAbolish = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="scope.row.isAbolish = false,del(scope.row)">确定</el-button>
                </div>
                <el-button class="marginLeft10" slot="reference" type="text">删除</el-button>
              </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change='pageSizeChange'
        @current-change='currentPageChange'
        :current-page.sync='currentPage'
        :page-sizes='[10, 20, 30]'
        :page-size='pageSize'
        layout='total, sizes, prev, pager, next, jumper'
        :total='total'>
      </el-pagination>
    </div>
    <!-- 新增按钮模态框 -->
    <el-dialog :title="title" :visible.sync="btnDialog" :before-close="handleClose" width="40%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" inline="">
        <el-row :gutter="3">
          <el-col :span="12">
            <el-form-item label="按钮名称:" :label-width="formLabelWidth" prop="name">
              <el-input v-model="ruleForm.name" auto-complete="off" size="small" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="状态:" :label-width="formLabelWidth" size="small" prop="status">
              <el-select v-model="ruleForm.status" placeholder="请选择">
                <el-option :key="1" label="启用" :value="1"></el-option>
                <el-option :key="2" label="禁用" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>

        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="父级菜单:" :label-width="formLabelWidth" size="small" prop="menuID">
              <el-select v-model="ruleForm.menuID" placeholder="请选择">
                <el-option v-for="item in menuList"
                :key="item.id"
                :label="item.menuName"
                :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="凭证:" :label-width="formLabelWidth" prop="voucher">
              <el-input v-model="ruleForm.voucher" auto-complete="off" size="small" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-row>
          <el-col :span="2" :offset="17">
            <el-button @click="btnDialog= false" size="small">取 消</el-button>
          </el-col>
          <el-col :span="2" :offset="2">
            <el-button type="primary" @click="handleSubmit('ruleForm')" size="small">确 定</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import isShowButton from '@/mixins'
export default {
  mixins: [isShowButton],
  data() {
    return {
      loading: true,
      isCompleted: false, //是否请求完成
      btnPremissionList: [],
      menuId: this.$route.query.menuId,

      title: '',
      value: '', //状态
      keyword: '',
      currentPage: 1,
      pageSize: 10,
      tableData: [{
        name: '按钮名称',
        status: 1,
        voucher: '凭证',
        isAbolish: false
      }],
      btnDialog: false,
      formLabelWidth: '80',
      ruleForm: {
        name: '',
        status: '',
        voucher: '',
        menuID: ''
      },
      menuList: [{
        menuName: '菜单',
        id: 1
      }],
      rules: {
        name: [{
          required: true, message: "请输入按钮名称", trigger: "blur" }
        ],
        voucher: [{
          required: true, message: "请输入菜单凭证", trigger: "blur"
        }],
        menuID: [{
          required: true, message: "请选择父级菜单", trigger: "change"
      }]},
      totalCache: 0
    }
  },
  created() {
    // console.log('created')
    this.getBtnRole()
    this.getBtnList(1, 10)
    this.getAllMenu()
  },
  computed: {
    total() {
      return parseInt(this.totalCache)
    }
  },
  methods: {
    handleClose(done){
      this.$confirm('关闭后信息不能保存,是否退出？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    // 获取所有菜单
    getAllMenu() {
      this.Axios.get('/api/Menu/GetAllMenu').then(res => {
        // console.log('res', res.data)
        if (res.status === 200) {
          this.menuList = res.data.data
          // console.log('menuList', this.menuList)
        }
      })
    },
    searchBtn(keyword, status) {
      this.getBtnList(this.currentPage, this.pageSize, keyword, status)
    },
    reset() {
      this.keyword = ''
      this.value = ''
      this.getBtnList(this.currentPage, this.pageSize)
    },
    // 点击新增按钮
    handleAdd() {
      this.title = '新增按钮'
      this.btnDialog = true
      this.ruleForm.id = undefined
      this.ruleForm.status = ''
      this.ruleForm.name = '',
      this.ruleForm.menuID = '',
      this.ruleForm.voucher = ''
    },
    // 点击编辑按钮
    handleEdit(val) {
      this.title = '编辑按钮'
      this.btnDialog = true
      this.getBtnInfoById(val.id)
    },
    // 根据id获取按钮信息
    getBtnInfoById(id) {
      this.Axios.get('/api/Button/GetButtonInfo', {
        params: {
          btnID: id
        }
      }).then(res => {
        // console.log(res.data)
        const data = res.data
        if (data.status == 100) {
          this.ruleForm =  data.data
        } else {
          this.$message({
            showClose: true,
            message: '获取信息失败!',
            type: 'error'
          })
        }
      })
    },
    // 执行新增操作
    doAddEditBtn() {
      const formData = JSON.parse(JSON.stringify(this.ruleForm))
      if (formData.id == undefined) {
        this.Axios.post('/api/Button/InsertBtn', formData).then(res => {
          // console.log(res.data)
          const data = res.data
          if (data.status == 100) {
            this.$message({
              showClose: true,
              message: '添加成功!',
              type: 'success'
            })
            this.btnDialog = false
            this.getBtnList(this.currentPage, this.pagesize)
          } else {
            this.$message({
              showClose: true,
              message: '添加失败!',
              type: 'error'
            });
          }
        })
      } else {
        this.Axios.put('/api/Button/UpateBtn', formData).then(res => {
          // console.log(res.data)
          const data = res.data
          if (data.status == 100) {
            this.$message({
              showClose: true,
              message: '修改成功!',
              type: 'success'
            })
            this.btnDialog = false
            this.getBtnList(this.currentPage, this.pagesize)
          } else {
            this.$message({
              showClose: true,
              message: '修改失败!',
              type: 'success'
            })
          }
        })
      }

    },
    del(val) {
      this.Axios.delete('/api/Button/DeleteBtn?btnID=' + val.id).then(res => {
        // console.log(res.data)
        const data = res.data
        if (data.status == 100) {
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success'
          })
          this.getBtnList(this.currentPage, this.pageSize)
        } else {
          this.$message({
            showClose: true,
            message: '删除失败!',
            type: 'error'
          })
        }
      })
    },
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.doAddEditBtn()
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    getBtnList(currentPage, pageSize, keyword, status) {
      let parameter = {
        start: currentPage,
        pagesize: pageSize,
        keyword: keyword,
        status: status
      }
      parameter.keyword == '' ? delete parameter['keyword'] : parameter.keyword = keyword
      parameter.status == '' ? delete parameter['status'] : parameter.status = status
      this.loading = true
      this.Axios.get('/api/Button/SearchButton', {params: parameter}).then(res => {
        // console.log(res.data)
        const data = res.data
        if (data.status == 100) {
          this.tableData = data.data
          // console.log('tableData', this.tableData)
          this.totalCache = data.total
          this.loading = false
        } else {
          this.$message({
            showClose: true,
            message: '获取列表失败,请刷新重试!',
            type: 'error'
          })
        }
      })
    },
    pageSizeChange(pageSize) {
      // console.log(pageSize)
      this.getBtnList(this.currentPage, pageSize)
    },
    currentPageChange(currentPage){
      this.getBtnList(currentPage, this.pageSize)
    },



  }
}
</script>

<style lang="less">
  .btnManage {
    .breadcrumb {
    overflow: hidden;
    span,
    .el-breadcrumb {
      float: left;
    }
    span {
      font-size: 14px;
      color: #666;
      line-height: 1;
    }
  }
  .table-content {
    .tool-bar {
      padding: 0 20px;
      span {
        font-size: 14px;
        // color: rgba(0, 0, 0, 0.85);
        font-weight: 400;
      }
      .key-word,
      .status {
        width: 264px;
        margin-right: 40px;
      }
    }
    .el-table {
      margin: 20px 0;
      .marginRight10 {
        margin-right: 10px;
      }
    }
    .el-pagination {
      /deep/ .number,
      /deep/ .btn-prev,
      /deep/ .btn-next {
        background-color: #fff;
        border: 1px solid #d9d9d9;
        width: 32px;
        height: 32px;
      }
    }
  }
  }
</style>



// WEBPACK FOOTER //
// src/page/SystemSet/BtnManage.vue